import React from 'react';
import TitleHelmet from 'components/TitleHelmet';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacy-policy">
      <TitleHelmet title="Privacy Policy" />

      <h1>Privacy Policy</h1>
      <p>
        <em>Effective date: March 18, 2025</em>
      </p>

      <p>
        Productist LLC, operating fatscientist.com ("Site"), is committed to protecting your privacy. This privacy
        policy outlines what information we collect, how it is used, and your choices regarding this information.
      </p>

      <h2>Information Collection</h2>
      <p>
        We do not collect personal information from users of this Site. No user-specific data is gathered or stored by
        Productist LLC.
      </p>

      <h2>Usage Data</h2>
      <p>
        We may collect aggregate usage data to better understand how our Site is used. This information is collected in
        a way that does not identify individual users. It is used solely for improving the content and user experience
        of our Site.
      </p>

      <h2>Google Services</h2>
      <p>This Site uses Google AdSense and Google Analytics:</p>
      <ul>
        <li>
          <strong>Google Analytics</strong> is used to collect aggregate data about website traffic and usage patterns.
          This data helps us improve the Site, and it is collected without identifying individual users.
        </li>
        <li>
          <strong>Google AdSense</strong> is used to display ads. These ads may use cookies to serve relevant
          advertisements based on your browsing behavior. You can manage your ad preferences through Google's Ad
          Settings.
        </li>
      </ul>

      <h2>Cookies</h2>
      <p>
        Third-party vendors, including Google, may use cookies to serve ads based on your previous visits to this Site
        or other websites. You can opt out of personalized advertising by visiting{' '}
        <a href="https://adssettings.google.com/">Google Ads Settings</a>.
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        We reserve the right to modify this privacy policy at any time. Changes will be posted on this page, and
        continued use of the Site will be considered acceptance of any changes.
      </p>

      <h2>Contact</h2>
      <p>If you have any questions about this privacy policy, please contact:</p>
      <p>
        Productist LLC
        <br />
        <a href="mailto:productist@fastmail.com">productist@fastmail.com</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
